'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Role {
  id: string;
  title: string;
  description: string;
  icon: string;
}

interface RoleSelectorProps {
  roles: Role[];
  selectedRole: string;
  onSelectRole: (roleId: string) => void;
}

const RoleSelector = ({ roles, selectedRole, onSelectRole }: RoleSelectorProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {roles.map((role) => {
        const isSelected = selectedRole === role.id;
        return (
          <button
            key={role.id}
            onClick={() => onSelectRole(role.id)}
            className={`p-6 rounded-lg border-2 transition-all duration-300 text-left ${
              isSelected
                ? 'border-primary bg-primary/5 shadow-authority'
                : 'border-border hover:border-primary/50 hover:shadow-subtle'
            }`}
          >
            <div className="flex flex-col items-center text-center">
              <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 ${
                isSelected ? 'bg-primary text-white' : 'bg-muted text-primary'
              }`}>
                <Icon name={role.icon as any} size={32} />
              </div>
              <h3 className={`text-lg font-display font-semibold mb-2 ${
                isSelected ? 'text-primary' : 'text-secondary'
              }`}>
                {role.title}
              </h3>
              <p className="text-sm text-muted-foreground">{role.description}</p>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default RoleSelector;